module.exports = __webpack_public_path__ + "img/Terraform-4.4d99dc0e.png";